import { ManageFacilityPlacementsSelect } from "./ManageFacilityPlacementsSelect";
import { Stack } from "@mui/material";
import { UseGetFacilityProfileResponse } from "@src/appV2/FacilityProfile/api/useGetFacilityProfile";
import { Title } from "@src/lib/ui-react";
import { useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";

export function FacilityPlacementSettings({
  facilityProfile,
}: {
  facilityProfile: UseGetFacilityProfileResponse;
}) {
  const isParentManagedPlacementsEnabled = useCbhFlag(
    CbhFeatureFlag.ROLLOUT_PARENT_MANAGED_PLACEMENTS,
    { defaultValue: false }
  );

  if (!isParentManagedPlacementsEnabled) {
    return null;
  }

  return (
    <Stack gap={2} sx={{ marginLeft: 2 }}>
      <Title component="h3">Job Settings</Title>
      <Stack gap={1}>
        <ManageFacilityPlacementsSelect facilityProfile={facilityProfile} />
      </Stack>
    </Stack>
  );
}
